import { Helmet } from "react-helmet-async";

const SITE_URL = "https://daroulmes.store";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

export default function SEO({
  title = "Dar Oulmès Store — Local Products in Oulmès",
  description = "Shop local products from Oulmès: jewellery, clothes, kitchen essentials, and makeup at reasonable prices with simple WhatsApp ordering.",
  canonical = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  jsonLd,
  noindex = false,
}) {
  const fullUrl = canonical.startsWith("http")
    ? canonical
    : `${SITE_URL}${canonical}`;

  const fullImage = image?.startsWith("http")
    ? image
    : `${SITE_URL}${image || "/og-image.jpg"}`;

  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? "noindex,nofollow" : "index,follow"} />

      <link rel="canonical" href={fullUrl} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="Dar Oulmès Store" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}